/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol = _interopDefault(require('openlayers'));
var core = require('../core');

/**
 * @vueProps
 */

/**
 * @module tile-layer/layer
 */
var TileLayer = __ol.layer.Tile;
var props = /** @lends module:tile-layer/layer# */{
  preload: Number

  /**
   * @vueMethods
   */
};var methods = /** @lends module:tile-layer/layer# */{
  /**
   * @return {ol.layer.Tile}
   * @protected
   */
  createLayer: function createLayer() {
    return new TileLayer({
      id: this.id,
      minResolution: this.minResolution,
      maxResolution: this.maxResolution,
      opacity: this.opacity,
      visible: this.visible,
      preload: this.preload,
      extent: this.extent ? core.projHelper.extentFromLonLat(this.extent, this.$view.getProjection()) : undefined,
      zIndex: this.zIndex,
      source: this._source
    });
  }
};

/**
 * Layer that provide pre-rendered, tiled images in grid that are organized by zoom levels for
 * specific resolutions. `vl-tile-layer` component implements a **source container** interface, so it should be
 * used together with tile-like `vl-source-*` components.
 *
 * @title vl-tile-layer
 * @alias module:tile-layer/layer
 * @vueProto
 *
 * @vueSlot default Default slot for `vl-source-*` (tile-like only) components.
 */
var Layer = {
  name: 'vl-layer-tile',
  mixins: [core.layer],
  props: props,
  methods: methods
};

/**
 * @module tile-layer
 */
/**
 * @alias module:tile-layer
 *
 * @example Install
 * import Vue from 'vue'
 * // import module and styles
 * import { TileLayer } from 'vuelayers'
 * // or
 * import TileLayer from 'vuelayers/lib/tile-layer'
 * // import VueLayers styles
 * import 'vuelayers/lib/style.css'
 * // register components
 * Vue.use(TileLayer)
 */
var index = {
  /**
   * Layer that provide pre-rendered, tiled images in grid that are organized by zoom levels for
   * specific resolutions.
   * @alias module:tile-layer/layer
   */
  Layer: Layer,
  install: function install(Vue) {
    Vue.component(Layer.name, Layer);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/tile-layer/index.js
// module id = 1201
// module chunks = 1